import { useEffect, useState } from "react";
import { GAME_CONFIG } from "../config.js";

const MIN_DISPLAY_MS = 3000;
const FADE_MS = 600;

interface Props {
  onDone: () => void;
}

export function LoadingScreen({ onDone }: Props) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFading(true), MIN_DISPLAY_MS);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!fading) return;
    const timer = setTimeout(onDone, FADE_MS);
    return () => clearTimeout(timer);
  }, [fading, onDone]);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: GAME_CONFIG.loadingScreenColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: `opacity ${FADE_MS}ms ease-out`,
        opacity: fading ? 0 : 1,
        zIndex: 9999,
      }}
    >
      <img
        src="/images/loading-logo.jpg"
        alt="Solitaire"
        style={{ maxWidth: "50%", maxHeight: "50%", objectFit: "contain" }}
      />
    </div>
  );
}
